import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { CrmActivity, CrmSummary, Opportunity, OpportunityStatus } from '../interfaces/opportunity';
import { Paged } from '../interfaces/paged';

@Injectable({ providedIn: 'root' })
export class OpportunityService extends APIService {
  list(page: number = 1, filters: any = {}, sorts: { col: string; dir: number }[] = [], per_page: number = null): Promise<Paged<Opportunity>> {
    const params: any = { page, per_page, ...filters };
    if (sorts && sorts.length) {
      params.sorts = JSON.stringify(sorts);
    }
    const qs = Object.keys(params)
      .map(k => {
        const v = typeof params[k] === 'object' && params[k] !== null ? JSON.stringify(params[k]) : params[k];
        return `${encodeURIComponent(k)}=${encodeURIComponent(v)}`;
      })
      .join('&');
    return this.get<Paged<Opportunity>>(`/opportunities?${qs}`);
  }
  show(id: number) { return this.get<Opportunity>(`/opportunities/${id}`); }
  create(payload: Partial<Opportunity>) { return this.post<Partial<Opportunity>, Opportunity>('/opportunities', payload); }
  update(id: number, payload: Partial<Opportunity>) { return this.put<Partial<Opportunity>, Opportunity>(`/opportunities/${id}`, payload); }
  setStatus(id: number, status: OpportunityStatus) { return this.put(`/opportunities/${id}/status`, { status }); }
  reopen(id: number) { return this.put(`/opportunities/${id}/reopen`, {}); }
  deleteOpportunity(id: number) { return this.delete(`/opportunities/${id}`); }
  activities(id: number) { return this.get<{ data: CrmActivity[] }>(`/opportunities/${id}/activities`); }
  logActivity(id: number, type: string, body: string, Contact_id?: number | null, occurred_at?: string) {
    return this.post<{ type: string; body: string; Contact_id?: number | null; occurred_at?: string }, { data: CrmActivity }>(
      `/opportunities/${id}/activities`, { type, body, Contact_id, occurred_at },
    );
  }
  summary() { return this.get<CrmSummary>('/crm/summary'); }
}
